import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home-item-icon5",
  "use": "icon-home-item-icon5-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-home-item-icon5\">\n<g>\n\t<path d=\"M10.4,13.9l-0.5,0.7c0,0-0.3,0.6,0.3,0.9c1.8,0.8,2.3,1.9,2.6,2.3c0.3,0.3,0.7,0.3,0.9-0.1c0.7-1.4,1.5-4.5,5.2-7.3\n\t\tc-4.3,1.5-5.6,4.9-5.6,4.9s-0.8-1.2-1.8-1.6C10.7,13.5,10.4,13.9,10.4,13.9z\" />\n\t<path d=\"M9.8,16.8c-0.5-0.2-0.9-0.6-1-1.1c-0.2-0.5-0.1-1,0.1-1.5c0,0,0-0.1,0.1-0.1l0.5-0.7c0.4-0.5,0.9-0.8,1.6-0.8\n\t\tc0.3,0,0.7,0.1,1,0.2c0.4,0.2,0.7,0.4,1.1,0.7c0.2-0.2,0.4-0.5,0.6-0.8c-0.7-0.4-1.5-0.8-2.4-1c-0.1,0-0.7-0.3-0.3-1.4l0,0\n\t\tc0.9-1,1.6-2.7,1.6-4.3c0-2.5-1.5-3.8-3.4-3.8S5.9,3.2,5.9,5.7C5.9,7.3,6.5,9,7.5,10c0.4,1-0.3,1.4-0.4,1.4c-2,0.7-4.3,2.1-4.3,3.4\n\t\tv0.5c0,1.8,3.4,2.2,6.5,2.2c0.5,0,1,0,1.5,0C10.5,17.2,10.2,16.9,9.8,16.8z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home-item-icon5.svg
// module id = omDt
// module chunks = 97